module.exports = __webpack_public_path__ + "fun_2.90797220b2c109338f0bb883a8a1a411.jpg";